import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { SsoView } from './sso/sso';

export const AuthView = angular
  .module('acme.view.auth', [uiRouter, 'ui.bootstrap', 'acme.common.service.api', SsoView])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'auth',
      url: '/auth',
      abstract: true,
      views: {
        main: {
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
      data: {
        pageClass: 'application-splash',
        pageTitle: 'Auth',
      },
    });
  }).name;
